module.exports = __webpack_public_path__ + "img/ekie_EN.879425eb.png";